<div class="selector-container">
  <div class="always-visible-container" (click)="onExpand()">
    <div class="left-side">
      <span class="selector-title">{{filterSelectorVM.filterTypeText}}</span>
      @if (dateFilterViewModel?.dateRangeOption) {
        <span class="selector-count">1</span>
        @if (expanded) {
          <app-button-transparent [text]="'Clear filters'" (clicked)="onClear()"></app-button-transparent>
        }
      }
      <!-- <span class="selector-count">{{getDateFilterText()}}</span> -->
    </div>
    <div class="right-side">
      <i class="material-symbols-outlined expand-icon">expand_more</i>
    </div>
  </div>
  @if (expanded) {
    <div class="hidding-container">
      <div class="dates-select-container">
        <ng-container>
          <div class="filters-date-relative-range-container">
            <div class="date-options custom-scrollbar">
              <div class="date-option-container">
                <app-radio-button
                [text]="'None'"
                [checked]="isNoneFilterSelected()"
                (checkedChanged)="onClear()"
                ></app-radio-button>
              </div>
              <div class="date-option-container fixed-radio">
                <app-radio-button
                [checked]="isFixedRangeSelected()"
                [text]="'Fixed Dates'"
                (click)="openDatepicker($event)"
                ></app-radio-button>
                <span class="material-symbols-outlined open-modal-icon ms-2"
                #openDatepickerIcon
                ngRangeDatepicker
                [startDate]="fromDate"
                [endDate]="toDate"
                [timePicker]="showTimePicker"
                (datesChanged)="onDateRangeChanged($event)"
                >
                  open_in_new
                  </span>
              </div>

              @if (isFixedRangeSelected()) {
                <div class="range-time-field">
                  <!-- This allows click over text field when pointer events is none -->
                  <div class="text-field-overlay" (click)="openDatepicker($event)"></div>
                  <app-text-field
                  [placeholder]="''"
                  [useNgDateMask]="true"
                  [format]="dateFormat"
                  [separator]="'/'"
                  [ngModel]="getDateFilterText()"
                  ></app-text-field>
                </div>
              }

              @for (relativeOption of filterSelectorVM.dateRangeOptions; track relativeOption) {
                <div class="date-option-container">
                  <app-radio-button
                  [checked]="isSelected(relativeOption)"
                  [text]="sanitizeText(relativeOption)"
              (checkedChanged)="onRelativeDateSelected(relativeOption)"
                  ></app-radio-button>
                </div>
              }
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  }
</div>
